// extracted by mini-css-extract-plugin
module.exports = {"objectProductForm":"ObjectProductForm_objectProductForm__1i3Ti","add":"ObjectProductForm_add__316Vq","directionRow":"ObjectProductForm_directionRow__CGLJL"};